const global = {
  initCssVars: () => {
    setTimeout(() => {
      const arrs = {
        '--header-height': $('#static-header').outerHeight(),
      }
      Object.keys(arrs).forEach((key) => {
        let value = arrs[key];
        document.body.style.setProperty(key, `${value}px`);
      });
    }, 100);
  },

  decodeEntity: function(val) {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = val;
    return textarea.value;
  },
  decodeLocale: function(json_string) {
    return JSON.parse(global.decodeEntity(json_string).replaceAll('=>',':'));
  },

  scrollToAnchor: (anchor, cond_buffer = 0) => {
    let currentTop = $(window).scrollTop();
    let header = $('#static-header');
    let el = $('a[name="'+anchor+'"]');
    if (el.length == 0) return;

    let pos = el.offset().top;
    pos -= currentTop > pos ? header.outerHeight() : cond_buffer;
    // pos -= $(window).width() > 480 ? 80 : 40;
    
    $('html,body').stop().animate({
      scrollTop: Math.ceil(pos),
    }, 500);
  },
  initScrollSpy: (menu_el) => {
    menu_el = menu_el || 'div[id*="sticky-menu"]';
    if (menu_el.length == 0) return;

    let elems = $('.scrollspy-link', menu_el);
    if (elems.length == 0) return;

    $(window).on('scroll', function() {
      let body = $('body');
      let header = $('#static-header');
      let main = $('.main-content');
      let currentTop = $(this).scrollTop();

      let navElem = false;
      elems.each(function(index) {
        let link = $(this).attr('href').trim();
        let is_link = link.indexOf('/') >= 0 || link.indexOf('http') >= 0;
        if (is_link) return;

        let name = link.replace('#', ''),
            _this = $('.main-content a[name="'+name+'"]');

        if (_this.length == 0) return;

        let elemTop = (
          _this.offset().top 
          - (body.hasClass('scroll-top') ? header.outerHeight()*2 : 0)
          - (body.hasClass('scroll-btm') ? header.outerHeight()*1.5 : 0)
          - ($(window).width() > 480 ? 80 : 40)
        );

        let bottom = elems.get(index+1);
        let elemBottom = (
          elemTop 
          + (typeof bottom !== 'undefined' ? $(bottom).offset().top : main.height())
        );
        
        if ((currentTop >= elemTop && currentTop <= elemBottom)) {
          navElem = $('.scrollspy-link[href="#'+name+'"]', menu_el);
        } else if ((elemTop == elemBottom && currentTop >= elemBottom)) {
          navElem = $('.scrollspy-link[href="#'+name+'"]', menu_el);
        }
      });

      if (navElem !== false && ! navElem.hasClass('active')) {
        navElem.addClass('active').siblings().removeClass('active');
      }
    });
  },
}

const video_player = {
  players: {},
  init: () => {
    if ($('.gpb-video').length == 0) return;

    $('.gpb-video').each(function(i) {
      let _t = $(this);
      let player = $('.gpb-video-player', _t);
      let player_data = player.data();
      let player_params = $('.gpb-video-player-params', _t).text();

      let videoObj = new VideoWorker(player_data.url, JSON.parse(player_params));
      if (videoObj.isValid()) {
        // youtube, vimeo
        videoObj.getVideo((video) => {
          const $parent = video.parentNode;
          player.html(video);
          $parent.parentNode.removeChild($parent);
        });

        video_player.players[player_data.id] = videoObj;
      } else {
        // html5
        videoObj = document.createElement('video');
        videoObj.src = player_data.url;
        videoObj.playsinline = true;
        player.get(0).appendChild(videoObj);
        videoObj.type = 'html5';
        video_player.players[player_data.id] = videoObj;
      }
    });

    $.each(video_player.players, function(i, videoObj) {
      if (videoObj.type == 'html5') {
        video_player.initEventHtml5(videoObj);
      } else {
        video_player.initEventWorker(videoObj);
      }
    });
    
    // play
    $('body').on('click', '.gpb-video .btn-play', function() {
      let obj = video_player.getVideoData($(this));

      video_player.players[obj.player_data.id].play();
    });
  },
  initEventHtml5: (videoObj) => {
    // play
    videoObj.addEventListener('play', (event) => {
      let obj = video_player.getVideoData($(event.target));

      obj.el_video.addClass('playing').removeClass('paused');
      
      video_player.players[obj.player_data.id].controls = true;
    });

    // pause
    videoObj.addEventListener('pause', (event) => {
      let obj = video_player.getVideoData($(event.target));

      obj.el_video.removeClass('playing').addClass('paused');

      video_player.players[obj.player_data.id].controls = false;
    });
  },
  initEventWorker: (videoObj) => {
    // play
    videoObj.on('play', (event) => {
      let obj = video_player.getVideoData($(event.target.g));

      obj.el_video.addClass('playing').removeClass('paused');
    });

    // pause
    videoObj.on('pause', (event) => {
      let obj = video_player.getVideoData($(event.target.g));
  
      obj.el_video.removeClass('playing').addClass('paused');
    });
  },
  getVideoData: (_t) => {
    let el_video = _t.parents('.gpb-video');
    let player = $('.gpb-video-player', el_video);
    let player_data = player.data();

    return {
      _t: _t,
      el_video: el_video,
      player: player,
      player_data: player_data,
    }
  },
}

const product = {
  initInputQty: () => {
    // qty
    $('body').on('click', '.product-input-qty-minus', function() {
      let qty = $(this).siblings('input');
      let val = qty.val();
      val--;
      qty.val(val >= 1 ? val : 1);
    });
    $('body').on('click', '.product-input-qty-plus', function() {
      let qty = $(this).siblings('input');
      let max = parseInt(qty.attr('max'));
      let val = qty.val();
      val++;
      qty.val(val >= max ? max : val);
    });
  },
  updateQty: (_t) => {
    let form = _t.parents('form');
    let qty = $('.product-input-qty', form);
    let qty_input = $('input', qty);
    
    if (_t[0].nodeName == 'SELECT') {
      _t = $('option:selected', _t);
    }
    let data_available = _t.attr('data-available');
    let data_quantity = _t.attr('data-quantity');

    if (data_available) {
      qty.removeClass('disabled');
      qty_input.val(qty_input.val() || 1).attr('max', data_quantity);
    } else {
      qty.addClass('disabled');
      qty_input.val(0).attr('max', 0);
    }
  },
  updatePrice: (_t) => {
    let form = _t.parents('form');
    let price_value = $('.product-grid-price-after', form);
    let price_before = $('.product-grid-price-before', form);

    price_value.html('');
    price_before.html('');

    let data_price_before = 0;
    let data_price_after = 0;
    $('select.variant_id option:selected, input.variant_id:checked, input[type="hidden"].variant_id', form).each(function() {
      data_price_before += parseInt($(this).attr('data-price_before') || 0);
      data_price_after += parseInt($(this).attr('data-price_after') || 0);
    });

    if (data_price_after == 0) {
      return;
    }

    // update total price
    price_value.html(Shopify.formatMoney(data_price_after));
    if (data_price_before != '' && data_price_before > data_price_after) {
      price_before.html(Shopify.formatMoney(data_price_before));
    }
  },
  updateAddToCart: (_t, el) => {
    let btn_submit = $('button.btn-add-to-cart', el);
    let btn_submit_text = $('.btn-add-to-cart-text', btn_submit);

    if (_t[0].nodeName == 'SELECT') {
      _t = $('option:selected', _t);
    }
    let data_available = _t.attr('data-available');

    if (data_available == 'true') {
      btn_submit.removeAttr('disabled').find('svg').show();
      btn_submit_text.html(btn_submit_text.attr('data-add-to-cart'));
    } else {
      btn_submit.attr('disabled', 'disabled').find('svg').hide();
      btn_submit_text.html(btn_submit_text.attr('data-sold-out'));
    }
  },
  updateVariant: (_t) => {
    // option / variant
    let form = _t.parents('form');

    // option
    if ($('input[name="option[]"]', form).length > 0) {
      let option_titles = [];
      $('input[name="option[]"]:checked', form).each(function() {
        option_titles.push($(this).val());
      });

      // variant dropdown
      let variant_dropdown = $('select.variant_id', form);
      let variant_option = $('option[data-title="'+option_titles.join(' / ')+'"]', variant_dropdown);
      if (variant_option.length > 0) {
        let variant_id = variant_option.attr('value');
        variant_dropdown.val(variant_id).trigger('change');
      }
    }
  },

  initProductGrid: () => {
    let body = $('body');

    // select variant
    body.on('change', '.product-grid .variant_id', function(e) {
      let _t = $(this);
      product.updateQty(_t);
      product.updatePrice(_t);
      product.updateAddToCart(_t, _t.parents('.product-grid').find('.product-grid-cta'))

      // slide gallery
      let data_image = _t.attr('data-image');
      let data_available = _t.attr('data-available');
      if (data_available) {
        let gallery_img = $('.product-grid-img img[data-image_id="'+data_image+'"]');
        console.log(data_image, gallery_img)
        if (gallery_img.length > 0) {
          gallery_img.addClass('active').siblings().removeClass('active');
        }
      }
    });
    // input variant / option
    body.on('change', '.product-grid .product-input-variant-group input[type="radio"]', function(e) {
      let _t = $(this);
      product.updateVariant($(this));

      // update option / variant group label
      let group_options = _t.parents('.product-input-variant-group-options');
      let group_label = group_options.prev('.product-input-variant-group-label');
      let group_label_selected = $('.product-input-variant-group-selected-value', group_label);
      let data_title = _t.attr('data-title');
      group_label_selected.html(data_title);
    });
    // add to cart
    body.on('click', '.product-grid .btn-add-to-cart', function(e) {
      e.preventDefault();
      let form = $(this).parents('form');
      product.setAddToCart(form);
    });
  },
  setAddToCart: (form) => {
    let items = [];
    $('select.variant_id, input.variant_id:checked, input[type="hidden"].variant_id', form).each(function() {
      let _t = $(this);
      let name = _t.attr('name');
      let qty = $('[name="quantity"]', form);
      if (name != 'id') {
        qty = $('[name="quantity['+name.replace('id','')+']"]', form);
      }

      items.push({
        id: _t.val(),
        quantity: parseInt(qty.val() || 1),
      });
    });

    // add to cart
    cart.addToCart({
      items: items
    });
  }
};

const cart = {
  addToCart: (data = false) => {
    if (data === false) {
      return false;
    }
    
    $.ajax({
      url: Shopify.routes.root + 'cart/add.js',
      type: 'post',
      dataType: 'json',
      data: data,
    })
    .done((res) => {
      $('.error-message').text('');
      gred.updateMinicart();
    })
    .fail((error) => {
      $('.error-message').text($.parseJSON(error.responseText).description);
      setTimeout(function() { 
        $('.error-message').text('');
      }, 8000);
    })
    .always(() => {
      $('.Drawer--right').addClass('active');
      $('.offcanvas-cart').addClass('active');
      $('.backdrop').addClass('active');
      $('body').addClass('ov-h');
    });
  },
}

$(() => {
  global.initScrollSpy();
  video_player.init();
  product.initInputQty();
  product.initProductGrid();
  global.initCssVars();
  $(window).on('load scroll resize orientationchange', global.initCssVars);
});